import BillingHistory from './BillingHistory';

export default BillingHistory;
